module.exports = __webpack_public_path__ + "static/media/perceelsidentificatie.a55d5f87.png";